import React from 'react';
import vl from '../images/vl.svg'
import StarRating from './rating';

const Card = ({ id,name, rating, recommendationCount,categoryName, address,profileImage,categoryId }) => {
    const goSingle = () => {
        sessionStorage.setItem('businessId',id)
        sessionStorage.setItem('categoryId',categoryId)
        sessionStorage.setItem('businessName',name)
        sessionStorage.setItem('currentCategory',categoryName)
        window.location.href='/business-details'
    }
    return (
        <div onClick={goSingle} className="cursor-pointer max-w-sm rounded-lg overflow-hidden border-[1px] border-[#EDEDED] bg-white">
            <div className="relative">
                <div className='relative'>
                    <img
                        src={profileImage ? profileImage.originalUrl : '' }
                        alt={name}
                        className="w-full h-48 object-cover"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                </div>
                <span
                className="absolute top-2 right-2 bg-[#A5A5A5] bg-opacity-25 text-white text-sm px-3 py-1 rounded-md"
                style={{  color: 'inherit' }}
                >
                <span className='text-white' style={{ opacity: 1 }}>{categoryName ? categoryName : sessionStorage.getItem('currentCategory')}</span>
                </span>
            </div>
            <div className="p-4 text-start h-[150px]">
                <h2 className="lg:text-[24px] text-[18px] font-[500] mb-2">{name}</h2>
                <div className="flex items-center mb-2">
                    {/* Render the stars */}
                    <StarRating 
                                    rating={rating} 
                                    maxRating={5} 
                                    readOnly 
                                />
                    <span className='ml-2'><img src={vl} /></span>
                    <span className="ml-2 text-sm text-gray-600">
                        {recommendationCount} Recommendations
                    </span>
                </div>
                <p className="text-gray-700 text-sm">{address}</p>
            </div>
        </div>
    );
};

export default Card;